import React from "react";

import { TextState, Preview } from "@creatomate/preview";

import { Trans } from "app/utils";
import { NumberField } from "@culturehq/components";

interface FontSizeProps {
  activeElement: TextState;
  onSubtitleChange?: (value: string) => Promise<void>;
  preview: Preview;
}

const MAX_FONT_SIZE = 1000;

const FontSize: React.FC<FontSizeProps> = ({
  activeElement,
  onSubtitleChange,
  preview
}) => {
  const handleFontSizeChange = async (value: string) => {
    let fontSize = +value;
    if (fontSize > MAX_FONT_SIZE) fontSize = MAX_FONT_SIZE;
    if (onSubtitleChange) {
      await onSubtitleChange(value);
    } else {
      await preview.applyModifications({
        [`${activeElement.source.id}.font_size`]: fontSize || null
      });
    }
  };

  return (
    <div className="chq-ffd">
      <NumberField
        className="chq-ffd-border"
        defaultValue={(activeElement.fontSize && Math.round(activeElement.fontSize))
          || activeElement.source.font_size}
        name="font-size"
        min={1}
        value={(activeElement.fontSize && Math.round(activeElement.fontSize))
          || activeElement.source.font_size}
        onChange={handleFontSizeChange}
      >
        <Trans>Size</Trans>
      </NumberField>
    </div>
  );
};

export default FontSize;
